import React from 'react'
import { useParams } from 'react-router-dom'
import { useSearchParam } from '../../../../../hooks/useSearchParam'
import { UserBatchDetails } from './UserBatchDetails'
import { BulkCreateUsersForm } from './CreateUserBatch/BulkCreateUsersForm'
import { BulkInviteUsersForm } from './CreateUserBatch/BulkInviteUsersForm'

export const UserBatch = (props) => {
  const { userBatchId } = useParams()
  const batchType = useSearchParam('batchType')

  if (userBatchId === 'new') {
    if (batchType === 'bulk-create-users') {
      return <BulkCreateUsersForm />
    }
    if (batchType === 'bulk-invite-users') {
      return <BulkInviteUsersForm />
    }
    return ''
  }

  return (
    <UserBatchDetails userBatchId={userBatchId} />
  )
}
